/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name no-console no-magic-numbers no-null-keyword

import { MockDataEndpoint, mockError, mockRegistry, mockRequest } from '@gh/core-data';

function mockGridLayout(name: string, columns: string[]): MockDataEndpoint {
  return mockRequest({
    url: `/bp/rest/grids/${name}`,
    data: {
      name,
      pageSize: 50,
      columns: columns.map((column, i) => ({
        column,
        position: i + 1,
        resizable: true,
        sortable: true,
        visible: true,
        width: 200,
      })),
    },
  });
}

function mockReport(name: string, url: string = 'about:blank'): MockDataEndpoint {
  return mockRequest({
    url: `/bp/rest/reports/${name}`,
    method: 'post',
    data: { linkToReport: url },
  });
}

const randomSelect = (...options: any[]) => options[Math.floor(Math.random() * options.length)];

export const BUILDER_MOCK_DATA = mockRegistry(
  // logRequest(mockRequest({
  //   url: '/bp/rest/system-variables/integration-accounts/accounting/sync-migrated',
  //   method: 'put',
  // })),
  // mockBusinessError({
  //   url: '/bp/rest/email-campaigns/6NWR',
  //   method: 'put',
  //   id: 'msg_no_campaign',
  // }),
  // logRequest(mockRequest({
  //   url: '/bp/rest/email-campaigns/6NWR',
  //   method: 'delete',
  // })),
  // mockReport('CASH_FLOW_FORECAST'),
  // mockRequest({ url: '/bp/rest/jobs/init', method: 'get', data: JOBS_INIT }),
  // mockPagination({ url: '/bp/rest/jobs', data: JOB_LIST }),
  // mockGridLayout('jobs', GRID_LAYOUT_JOBS),
  )
;
